import { useContext } from 'react';

import { useRouter } from 'next/router';

import HistoryContext from '../context/history/context';
import { GenerationStatus } from '../enums/generationStatus';
import { getIsResponsePopulated } from '../utils/responsePopulatedUtil';

interface UseShouldUseCacheResult {
  shouldUseCache: boolean;
  existingGenerationId?: string;
}

export function useShouldUseCache(): UseShouldUseCacheResult {
  const router = useRouter();
  const { historyItems } = useContext(HistoryContext);
  const generationId = router?.query?.id as string;

  // If not populated, user is in fresh workspace and shouldn't use cache
  const isResponsePopulated = getIsResponsePopulated();
  if (!isResponsePopulated) {
    return { shouldUseCache: false };
  }

  const getCurrentGeneration = () => {
    if (!generationId || !historyItems.length) {
      return null;
    }

    const foundGeneration = historyItems.find(
      (item) => item.id === generationId,
    );
    if (foundGeneration) {
      return foundGeneration;
    }

    const firstItem = historyItems[0];
    if (firstItem && firstItem.status === GenerationStatus.INCOMPLETE) {
      return firstItem;
    }

    return null;
  };

  const currentGeneration = getCurrentGeneration();
  const shouldUseCache =
    currentGeneration?.status === GenerationStatus.INCOMPLETE;

  return {
    shouldUseCache,
    existingGenerationId: currentGeneration?.id,
  };
}
